import { Container, Nav, Navbar, NavDropdown } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { api } from 'services/api';
import { announcementAllUrl, registerUrl } from 'helper/helper';
import useSession from 'hooks/useSession';
import paths from 'router/paths';

import './TopNavi.scss';

import navImage from 'images/navImage.png';

export const TopNavi = () => {
    const navigate = useNavigate();
    const { user, signOut } = useSession();

    const onSignout = async () => {
        await api
            .post('/auth/logout')
            .then((res) => {
                if (res.status === 200) {
                    signOut();
                }
            })
            .catch((error) => {
                console.log(error);
            });
    };

    return (
        <Navbar className='navbar bg-white' sticky={'top'}>
            <Container className='navi_container'>
                <Navbar.Brand>
                    <Link to=''>
                        <img
                            src={navImage}
                            alt='navi_logo'
                            width='91'
                            height='46'
                            className='d-inline-block align-top'
                        />
                    </Link>
                </Navbar.Brand>
                <Navbar.Toggle aria-controls='basic-navbar-nav' />
                <Navbar.Collapse id='basic-navbar-nav'>
                    <Nav className='me-auto'>
                        <NavDropdown id='item' title='JUGO' renderMenuOnMount>
                            <NavDropdown.Item className='drop_item'>
                                <Link to={paths.ABOUT} className='sub_item'>
                                    SOBRE
                                </Link>
                            </NavDropdown.Item>
                            <NavDropdown.Item className='drop_item'>
                                <Link to='' className='sub_item'>
                                    Guia de Jogo
                                </Link>
                            </NavDropdown.Item>
                        </NavDropdown>

                        <Nav.Link className='item' href={announcementAllUrl}>
                            NOTÍCIAS
                        </Nav.Link>

                        <NavDropdown
                            id='item'
                            title='COMUNIDADE'
                            renderMenuOnMount
                        >
                            <div className='drop_item'>
                                <Link className='sub_item' to=''>
                                    <div>Discord</div>
                                </Link>
                            </div>
                            <div className='drop_item'>
                                <Link className='sub_item' to=''>
                                    <div>Facebook</div>
                                </Link>
                            </div>
                        </NavDropdown>

                        <Nav.Link className='item' href={paths.DOWNLOAD}>
                            BAIXAR
                        </Nav.Link>
                        <Nav.Link className='item' href={paths.SHOP_PATH}>
                            LOJA DE CASH
                        </Nav.Link>
                        <Nav.Link className='item' href={paths.SUPPORT_PATH}>
                            SUPORTE
                        </Nav.Link>
                        {!user && (
                            <>
                                <Nav.Link
                                    className='item'
                                    href={paths.LOGIN_PATH}
                                >
                                    ENTRAR
                                </Nav.Link>
                                <Nav.Link className='item' href={registerUrl}>
                                    CADASTRAR-SE
                                </Nav.Link>
                            </>
                        )}
                        {user && (
                            <>
                                <Nav.Link
                                    className='item'
                                    href={paths.PROFILE_PATH}
                                >
                                    Minhas Informações
                                </Nav.Link>
                                <Nav.Link className='item' onClick={onSignout}>
                                    SAIR
                                </Nav.Link>
                            </>
                        )}
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
};
